import { Grid } from "../../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { Currency, OpenCurrencyDialog } from "./dialogs/currencyDialog";
import { InternalCurrency } from "./dialogs/internalCurrencyDialog";
import React from "react";
interface MainGroupCurrenciesProps {
    idCurr: number;
    gridOptions: any;
}

export default class MainGroupCurrenciesGrid extends React.Component<MainGroupCurrenciesProps, {
    selectedItem: Currency,
    enableDeleteButton: boolean,
    gridData: Currency
}>{

    constructor(props) {
        super(props);
        this.state = {
            selectedItem: null,
            enableDeleteButton: false,
            gridData: null
        }
    }

    componentDidMount() {
        this.loadGridData();
    }

    componentDidUpdate(prevProps: MainGroupCurrenciesProps) {
        let idChanged = prevProps.idCurr != this.props.idCurr;
        if (idChanged)
            this.loadGridData();
    }

    private loadGridData = async () => {
        let result = await HTTPService.get<JsonResultClass<InternalCurrency>>("GeneralSettingsCurrency/GetCurrencies?idCurr=" + this.props.idCurr);
        if (result.Code == 0)
            this.setState({ gridData: result.Data });
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    private onSelectedChange = (dataItem: Currency) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ enableDeleteButton: dataItem.IsDeletable, selectedItem: dataItem });
        }
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: Currency) => {
        if (type == ToolBarStandardButtonType.EDIT) {
            this.onEditCurrency(dataItem);
        } else if (type == ToolBarStandardButtonType.NEW) {
            this.onCreateNewCurrency();
        } else if (type == ToolBarStandardButtonType.DELETE) {
            DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen")).then(isOk => {
                if (isOk) {
                    this.deleteCurrency(dataItem.GUID);
                }
            });
        }
    }

    private onEditCurrency = async (sourceCurrency: Currency) => {
        let currency = await OpenCurrencyDialog(sourceCurrency);
        sourceCurrency.Characters = currency.Characters;
        sourceCurrency.Currency = currency.Currency;
        sourceCurrency.Factor = currency.Factor;
        sourceCurrency.From = currency.From;
        sourceCurrency.Name = currency.Name;
        this.changeCurrency(sourceCurrency);
    }

    private changeCurrency = async (currency: Currency) => {
        let result = await HTTPService.post<JsonResultClass>("GeneralSettingsCurrency/ChangeCurrency", currency);
        if (result.Code == 0) {
            this.setState({}, () => this.loadGridData());
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    private onCreateNewCurrency = async () => {
        let currency = await OpenCurrencyDialog();
        currency.Id = this.props.idCurr;
        this.createNewCurrency(currency);
    }

    private createNewCurrency = async (currency: Currency) => {
        let result = await HTTPService.post<JsonResultClass>("GeneralSettingsCurrency/CreateNewCurrency", currency);
        if (result.Code == 0) {
            this.setState({}, () => this.loadGridData());
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    private deleteCurrency = async (isGuid: string) => {
        let result = await HTTPService.post<JsonResultClass>("GeneralSettingsCurrency/DeleteCurrency?isGuid=" + encodeURIComponent(isGuid));
        if (result.Code == 0) {
            this.setState({}, () => this.loadGridData());
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    private createGrid = () => {
        let grid = null;
        let fullLoaded: boolean = Helper.hasValue(this.state.gridData) && Helper.hasValue(this.props.gridOptions);

        if (fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.enableDeleteButton });
            grid =
                <Grid data={this.state.gridData} options={this.props.gridOptions} id="currenciesIdGrid" onSelectionChanged={this.onSelectedChange}
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton}
                />;
        }
        return grid;
    }

    render() {
        const grid = this.createGrid();
        return (<>
            {grid}
        </>)
    }
}